import {makeStyles} from '@material-ui/core/styles'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import logo from '../../1elements/Icons/svg/proximityLogo.svg'
import {Text} from '../../1elements'
import CloseButton from '../../1elements/Buttons/TextButtons/CloseButton'

const WelcomeMessage = ({title, description, footerDescription, handleClose}) => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardContent className={classes.innerDiv}>
                <img src={logo} alt={'Proximity'} className={classes.logo}/>
                <Text className={classes.title} type={'h1'}>{title}</Text>
                <Text className={classes.description} type={'p'}>{description}</Text>
                <div className={classes.footer}>
                    <Text type={'p'} className={classes.footerDescription}>{footerDescription}</Text>
                    {
                        handleClose
                            ? (
                                <CloseButton onClick={handleClose} />
                            )
                            : (
                                <CloseButton />
                            )
                    }
                </div>
            </CardContent>
        </Card>
    )
}

export default WelcomeMessage

const useStyles = makeStyles((theme)=>({
    root: {
        borderRadius: '23px !important',
        boxShadow: '1px 3px 5px #00000061 !important',
        maxWidth: 429,
        backgroundColor: `${theme.palette.quaternary.main} !important`
    },
    footer: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: 13
    },
    innerDiv: {
        margin: '23px 10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    title: {
        margin: '37px 0 29px'
    },
    description: {
        display: 'inline-block',
        minHeight: 85,
        whiteSpace: 'pre-wrap'
    },
    logo: {
        width: 247
    },
    footerDescription: {
        maxWidth: 270
    }
}))